// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"32aa850d","233":"d5bcf408","354":"bd53dea5","360":"f094557c","416":"8a5615e1","488":"6b1580dc","519":"2a17a409","604":"8ffc0731"}[chunkId] + ".chunk.js";
};